<div id="ui-view" [ngClass]="{ 'loding-ui-view': showloding }">
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-lg-12 headboxes">
        <div class="card p-0">
          <div class="card-block p-0">
            <div
              class="heading-box"
              style="background-image: url(assets/img/blog.png)"
            >
              <div class="row align-items-center">
                <div class="col-md-2">
                  <div class="pagename">
                    <h3 class="card-title">Mentorship Meetings</h3>
                  </div>
                </div>

                <div class="col-md-1">
                  <div class="total-count">
                    <h5 class="m-0">Total</h5>
                    <h2>
                      {{
                        totalmentorshipMeetings ? totalmentorshipMeetings : 0
                      }}
                    </h2>
                  </div>
                </div>

                <div class="col-md-9 text-end">
                  <div class="row align-items-end justify-content-end">
                    <div class="col-auto">
                      <div
                        class="row justify-content-around align-items-end position-relative searchx"
                      >
                        <div class="col-auto px-1">
                          <div class="total-count form-group mb-0">
                            <label for="" class="font-weight-normal m-0"
                              >Meeting Happened</label
                            >
                            <select
                              class="form-control ms_drpdown"
                              id="approve_status"
                              [(ngModel)]="filterData.status"
                              (change)="setFilterData($event)"
                            >
                              <option value="">ALL</option>
                              <option value="1">Yes</option>
                              <option selected value="0">No</option>
                            </select>
                          </div>
                        </div>

                        <div
                          class="col-auto px-1"
                          *ngIf="filterData.status == '1'"
                        >
                          <div class="total-count form-group mb-0">
                            <label for="" class="font-weight-normal m-0"
                              >Top Meeting</label
                            >
                            <select
                              class="form-control ms_drpdown"
                              id="approve_status"
                              [(ngModel)]="meetingData.status"
                              (change)="setTopMeetingData($event)"
                            >
                              <option value="" disabled>Select</option>
                              <option value="5">Top 5</option>
                              <option selected value="10">Top 10</option>
                            </select>
                          </div>
                        </div>

                        <div class="col-auto px-1">
                          <div class="form-group position-relative m-0">
                            <label for="" class="font-weight-normal m-0"
                              >From Date</label
                            >
                            <input
                              type="date"
                              class="form-control"
                              (keydown)="blockTyping($event)"
                              [max]="today"
                              autocomplete="off"
                              novalidate
                              name="startDate"
                              placeholder="Select Start Date"
                              [(ngModel)]="startDate"
                            />
                            <small
                              *ngIf="isSubmitted && !startDate && !dateInvalid"
                              class="text-danger position-absolute"
                              >From Date is required.</small
                            >
                          </div>
                        </div>

                        <div class="col-auto px-1">
                          <div class="form-group position-relative m-0">
                            <label for="" class="font-weight-normal m-0"
                              >To Date</label
                            >
                            <input
                              type="date"
                              class="form-control"
                              (keydown)="blockTyping($event)"
                              [max]="today"
                              autocomplete="off"
                              novalidate
                              name="endDate"
                              [(ngModel)]="endDate"
                              placeholder="Select End Date"
                            />
                            <small
                              *ngIf="isSubmitted && !endDate && !dateInvalid"
                              class="text-danger position-absolute"
                              >To Date is required.</small
                            >
                          </div>
                        </div>

                        <div class="col-auto px-1">
                          <button
                            class="border-0 cross-icon1"
                            (click)="onSearch()"
                          >
                            <i class="fa fa-search" aria-hidden="true"></i>
                          </button>
                        </div>

                        <div class="col-auto px-1">
                          <button
                            class="border-0 cross-icon1"
                            (click)="onReset()"
                          >
                            <i class="fa fa-refresh" aria-hidden="true"></i>
                          </button>
                        </div>

                        <small
                          *ngIf="
                            isSubmitted && dateInvalid && startDate && endDate
                          "
                          class="text-danger d-block text-center"
                          style="
                            position: absolute;
                            bottom: -20px;
                            margin-left: -50px;
                          "
                        >
                          Please ensure the From Date is earlier than or equal
                          to the To Date
                        </small>
                      </div>
                    </div>

                    <div class="col-auto px-1">
                      <div class="excel">
                        <button
                          type="button"
                          [disabled]="!exl"
                          class="btn btn-primary addbtn"
                          (click)="exportToExcel()"
                        >
                          <i class="fa fa-file-excel-o"></i>&nbsp; Export
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="card">
          <div class="card-block">
            <div id="table" class="table-responsive">
              <table
                datatable
                id="meetingss"
                [dtOptions]="dtOptions"
                [dtTrigger]="dtTrigger"
                class="table"
                width="100%"
              >
                <thead>
                  <tr>
                    <th>#Sl</th>
                    <th>Meeting Id</th>
                    <th>Organizer Name</th>
                    <th>Invitee Name</th>
                    <th>Topic</th>
                    <th>Content</th>
                    <th>Scheduled From</th>
                    <th>Scheduled to</th>
                    <th>Created at</th>
                    <th>Meeting Happened</th>
                    <th>Duration</th>
                  </tr>
                </thead>

                <tbody *ngIf="mentorshipMeetingArr?.length != 0">
                  <tr
                    *ngFor="let item of mentorshipMeetingArr; let i = index"
                    [attr.data-index]="i"
                  >
                    <td>{{ i + 1 }}</td>
                    <td>{{ item.id }}</td>
                    <td>{{ item.organizer_name }}</td>
                    <td>{{ item.invitee_names }}</td>
                    <td>{{ item.topic }}</td>
                    <td>{{ item.content }}</td>
                    <td>{{ item.start_from }}</td>
                    <td>{{ item.end_to }}</td>
                    <td>{{ item.created_at }}</td>
                    <td>{{ item.meeting_happened }}</td>
                    <td>
                      {{
                        filterData.status == "1" ? item.total_overlap_time : "-"
                      }}
                    </td>
                  </tr>
                </tbody>

                <tbody *ngIf="mentorshipMeetingArr?.length == 0">
                  <tr>
                    <td colspan="11" class="no-data-available text-center">
                      No data available!
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
